import React from 'react';
import { Check } from 'lucide-react';

const PasswordRequirements = ({ password }) => {
  const requirements = [
    { 
      label: 'Al menos 8 caracteres',
      met: password.length >= 8 
    },
    { 
      label: 'Una letra mayúscula',
      met: /[A-Z]/.test(password)
    },
    { 
      label: 'Una letra minúscula',
      met: /[a-z]/.test(password)
    },
    { 
      label: 'Un número',
      met: /[0-9]/.test(password)
    },
    { 
      label: 'Un carácter especial (!@#$%^&¿?*)',
      met: /[!@#$%^&¿?*]/.test(password)
    }
  ];

  const allRequirementsMet = requirements.every(req => req.met);

  return (
    <div className="mt-3 space-y-2">
      <p className="text-sm font-medium text-gray-700">
        La contraseña debe tener:
      </p>
      
      <div className="space-y-2">
        {requirements.map((req, index) => (
          <div 
            key={index} 
            className={`flex items-center gap-2 transition-colors ${
              req.met ? 'text-green-600' : 'text-gray-500'
            }`}
          >
            <div className={`
              w-5 h-5 rounded-full flex items-center justify-center
              ${req.met ? 'bg-green-100' : 'bg-gray-100'}
            `}>
              <Check 
                size={14} 
                className={req.met ? 'text-green-600' : 'text-gray-400'} 
              />
            </div>
            <span className="text-sm">{req.label}</span>
          </div>
        ))}
      </div>

      {password && (
        <div className="mt-3">
          <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div 
              className={`h-full transition-all duration-300 ${
                allRequirementsMet 
                  ? 'bg-green-500'
                  : password.length >= 1 
                    ? 'bg-yellow-500'
                    : 'bg-gray-200'
              }`}
              style={{ 
                width: `${Math.min(
                  100, 
                  (requirements.filter(r => r.met).length / requirements.length) * 100
                )}%`
              }}
            />
          </div>
          <p className={`text-xs mt-1 ${
            allRequirementsMet 
              ? 'text-green-600'
              : 'text-gray-500'
          }`}>
            {allRequirementsMet 
              ? 'Contraseña segura'
              : 'Completa todos los requisitos para una contraseña segura'}
          </p>
        </div>
      )}
    </div>
  );
};

export default PasswordRequirements;